import { render, staticRenderFns } from "./directAccessMenu.vue?vue&type=template&id=7566a823"
import script from "./directAccessMenu.vue?vue&type=script&lang=ts"
export * from "./directAccessMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports